import '../social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramContent extends Monitoring.Models.SocialContents.SocialContent

  avatar: ->
    return @interaction().author.avatar if @interaction()?.author?.avatar
    @author().profile_picture || window.image_path("default_instagram_avatar.png")

  content: ->
    return if @caption() then @caption().text else ''

  contentUrl: ->
    @data().link

  caption: ->
    @data().caption

  username: ->
    return @interaction().author.username if @interaction()?.author?.username
    return @author().username

  name: ->
    return @interaction().author.name if @interaction()?.author?.name
    return @author().full_name || @username()

  userId: ->
    return @interaction().author.id

  created_at: ->
    return @interaction().created_at if @interaction()
    return @data().created_time * 1000 if @data().created_time

  marketingAccountId: ->
    return @data().marketing_account_id

  isAd: ->
    return @data().is_ad

  isMention: ->
    return @data().is_mention

  data: ->
    return @get('data')

  userLink: ->
    return "https://instagram.com/#{@username()}/"

  getImmediateParentId: ->
    ''

  hasAttachments: ->
    false

  getAttachments: ->
    []
